<app-cache-debug-badge />
<main class="flex flex-row h-screen font-main font-inter">
  <!-- Mobile backdrop overlay (transparent, just for click to close) -->
  @if (isMobileSidebarOpen()) {
    <div
      class="fixed inset-0 z-40 md:hidden"
      (click)="closeMobileSidebar()"
    ></div>
  }

  <!-- Sidebar: hidden on mobile, shown as overlay when open -->
  <dashboard-sidebar
    [ngClass]="{
      'w-[256px]': !isCollapsed() || isMobileSidebarOpen(),
      'w-[80px]': isCollapsed() && !isMobileSidebarOpen(),
      'translate-x-0 shadow-[4px_0_6px_-1px_rgba(0,0,0,0.1)]':
        isMobileSidebarOpen(),
      '-translate-x-full': !isMobileSidebarOpen(),
    }"
    [isMobileOpen]="isMobileSidebarOpen()"
    (sidebarWidth)="onSidebarWidthChange($event)"
    (mobileToggle)="closeMobileSidebar()"
    class="bg-white flex flex-col pt-2 fixed top-0 left-0 h-full transition-all duration-300 z-50 md:translate-x-0 md:shadow-none"
  />
  <div
    [ngClass]="{
      'md:ml-[256px]': !isCollapsed(),
      'md:ml-[80px]': isCollapsed(),
    }"
    class="flex-1 bg-[#F4F7FC] h-full overflow-y-auto p-0 transition-all duration-300 ml-0"
  >
    <!-- Mobile header with hamburger menu -->
    <div
      class="flex md:hidden flex-row justify-between items-center px-4 mb-4 gap-[10px] relative w-full h-[50px] bg-white"
    >
      <!-- Hamburger menu button -->
      <svg
        (click)="toggleMobileSidebar()"
        class="w-5 h-5 cursor-pointer"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="black" />
      </svg>
      <!-- Mobile signout (profile & logout icons) -->
      <dashboard-signout [isMobile]="true" class="flex items-center" />
    </div>

    <!-- Desktop signout header -->
    <div class="sticky left-0">
      <dashboard-signout
        class="hidden md:flex justify-end mt-1 xlplus:mt-3 mx-[24px] xlplus:mb-[30px]"
      />
    </div>
    <router-outlet></router-outlet>
    <p-dialog
      [modal]="true"
      [(visible)]="isUserEditDialogVisible"
      [baseZIndex]="500000"
    >
      <ng-template #headless>
        <div
          class="bg-white rounded-2xl min-h-[220px] xlplus:min-h-[252px] w-[calc(100vw-32px)] max-w-[490px] xlplus:max-w-[500px] p-[20px] md:p-[28px] xlplus:p-[32px]"
        >
          <div>
            <h3
              class="flex gap-[8px] items-center font-inter font-semibold text-[22px] xlplus:text-2xl"
            >
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.2992 1.64844L20.9332 16.6024C21.0648 16.8305 21.1341 17.0891 21.1341 17.3524C21.1341 17.6157 21.0648 17.8744 20.9332 18.1024C20.8015 18.3304 20.6122 18.5198 20.3842 18.6515C20.1561 18.7831 19.8975 18.8524 19.6342 18.8524H2.36617C2.10287 18.8524 1.84421 18.7831 1.61619 18.6515C1.38816 18.5198 1.19881 18.3304 1.06716 18.1024C0.935515 17.8744 0.866209 17.6157 0.866211 17.3524C0.866213 17.0891 0.935522 16.8305 1.06717 16.6024L9.70117 1.64844C10.2782 0.648438 11.7212 0.648438 12.2992 1.64844ZM11.0002 13.5004C10.735 13.5004 10.4806 13.6058 10.2931 13.7933C10.1055 13.9809 10.0002 14.2352 10.0002 14.5004C10.0002 14.7657 10.1055 15.02 10.2931 15.2075C10.4806 15.3951 10.735 15.5004 11.0002 15.5004C11.2654 15.5004 11.5197 15.3951 11.7073 15.2075C11.8948 15.02 12.0002 14.7657 12.0002 14.5004C12.0002 14.2352 11.8948 13.9809 11.7073 13.7933C11.5197 13.6058 11.2654 13.5004 11.0002 13.5004ZM11.0002 6.50044C10.7552 6.50047 10.5188 6.59039 10.3358 6.75315C10.1528 6.91591 10.0358 7.14019 10.0072 7.38344L10.0002 7.50044V11.5004C10.0005 11.7553 10.0981 12.0005 10.273 12.1858C10.448 12.3711 10.6871 12.4827 10.9416 12.4976C11.196 12.5125 11.4466 12.4298 11.642 12.2662C11.8375 12.1026 11.9631 11.8705 11.9932 11.6174L12.0002 11.5004V7.50044C12.0002 7.23522 11.8948 6.98087 11.7073 6.79333C11.5197 6.60579 11.2654 6.50044 11.0002 6.50044Z"
                  fill="#E73A3A"
                />
              </svg>
              Important Account Update
            </h3>
          </div>
          <p
            class="font-lato font-normal text-taxpod-gray text-sm xlplus:text-base mt-[16px]"
          >
            Your information has been updated.
          </p>
          <p
            class="font-lato font-normal text-taxpod-gray text-sm xlplus:text-base mt-[16px]"
          >
            For security reasons, you’ll be logged out in {{ editLogoutCountdown() }} seconds.
          </p>
          <div class="flex justify-end mt-[20px]">
            <p-button
              label="Logout"
              variant="outlined"
              (onClick)="closeUserEditDialog()"
              styleClass="!w-[80px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !mr-2 !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
            />
          </div>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      [modal]="true"
      [(visible)]="isUserDeleteDialogVisible"
      [baseZIndex]="500000"
    >
      <ng-template #headless>
        <div
          class="bg-white rounded-2xl min-h-[250px] xlplus:min-h-[272px] w-[calc(100vw-32px)] max-w-[500px] xlplus:max-w-[510px] p-[20px] md:p-[28px] xlplus:p-[32px]"
        >
          <div>
            <h3
              class="flex gap-[8px] items-center font-inter font-semibold text-[22px] xlplus:text-2xl"
            >
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.2992 1.64844L20.9332 16.6024C21.0648 16.8305 21.1341 17.0891 21.1341 17.3524C21.1341 17.6157 21.0648 17.8744 20.9332 18.1024C20.8015 18.3304 20.6122 18.5198 20.3842 18.6515C20.1561 18.7831 19.8975 18.8524 19.6342 18.8524H2.36617C2.10287 18.8524 1.84421 18.7831 1.61619 18.6515C1.38816 18.5198 1.19881 18.3304 1.06716 18.1024C0.935515 17.8744 0.866209 17.6157 0.866211 17.3524C0.866213 17.0891 0.935522 16.8305 1.06717 16.6024L9.70117 1.64844C10.2782 0.648438 11.7212 0.648438 12.2992 1.64844ZM11.0002 13.5004C10.735 13.5004 10.4806 13.6058 10.2931 13.7933C10.1055 13.9809 10.0002 14.2352 10.0002 14.5004C10.0002 14.7657 10.1055 15.02 10.2931 15.2075C10.4806 15.3951 10.735 15.5004 11.0002 15.5004C11.2654 15.5004 11.5197 15.3951 11.7073 15.2075C11.8948 15.02 12.0002 14.7657 12.0002 14.5004C12.0002 14.2352 11.8948 13.9809 11.7073 13.7933C11.5197 13.6058 11.2654 13.5004 11.0002 13.5004ZM11.0002 6.50044C10.7552 6.50047 10.5188 6.59039 10.3358 6.75315C10.1528 6.91591 10.0358 7.14019 10.0072 7.38344L10.0002 7.50044V11.5004C10.0005 11.7553 10.0981 12.0005 10.273 12.1858C10.448 12.3711 10.6871 12.4827 10.9416 12.4976C11.196 12.5125 11.4466 12.4298 11.642 12.2662C11.8375 12.1026 11.9631 11.8705 11.9932 11.6174L12.0002 11.5004V7.50044C12.0002 7.23522 11.8948 6.98087 11.7073 6.79333C11.5197 6.60579 11.2654 6.50044 11.0002 6.50044Z"
                  fill="#E73A3A"
                />
              </svg>
              Account Deactivated
            </h3>
          </div>
          <p
            class="font-lato font-normal text-taxpod-gray text-sm xlplus:text-base mt-[16px]"
          >
            Your information has been updated.
          </p>
          @if (timeToLogout()) {
            <p
              class="font-lato font-normal text-taxpod-gray text-sm xlplus:text-base mt-[16px]"
            >
              Your user account has been deactivated by an administrator. You
              will be automatically logged out and redirected to the login page
              in
              <span class="font-bold">{{ timeToLogout() }} </span>seconds.
            </p>
          }
          <div class="flex justify-end mt-[20px]">
            <p-button
              label="Logout Now"
              variant="outlined"
              (onClick)="closeUserDeleteDialog()"
              styleClass="!w-[110px] xlplus:!w-[130px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !mr-2 !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
            />
          </div>
        </div>
      </ng-template>
    </p-dialog>
  </div>
  <interactive-toast [key]="'form'"></interactive-toast>
  <!--
    Unkeyed outlet (no [key] input at all) for messages raised by ROOT-provided
    services, which have no component-scoped MessageService of their own:
    filing-load failures (SheetLoadTraceService.failures$) and IndexedDB write
    errors (FilingFormPersistenceService.writeErrors$). Both must outlive the
    filing container — a `PERM` or `AUTH` conversion load failure navigates away,
    which destroys that container and its own keyed toast outlet in the same
    tick — so this one is declared here, at the always-mounted shell, instead.

    This used to be a plain `<p-toast>`, which renders PrimeNG's own default
    icon set — visibly different from every other toast in the app, which all
    go through `interactive-toast`'s custom SVGs. Reusing the same component
    with its `key` input omitted keeps the icon identical everywhere while
    still catching the unkeyed messages these two root services emit.
  -->
  <interactive-toast></interactive-toast>
</main>
